// Generated by Melange


function makeProps(ariaHidden, className, role, param) {
  return {
    "aria-hidden": ariaHidden,
    className: className,
    role: role
  };
}

export {
  makeProps,
}
/* No side effect */
